import React from "react";
import style from "./happen_banner.module.css";
export default function Happen_Banner() {
  return (
    <div className={style.happen_bg}>
      <div className={style.details}>
        <h3>What happened!</h3>
        <p>
          How to create mobile-optimized videos in minutes. Not a designer, every team makes a lot of videos Can be trimmed. Take the first step to
          your brand's success. How to create mobile-optimized videos in minutes.
        </p>
      </div>
    </div>
  );
}
